function toggleCustomize(el){
  el.closest("product-info")?.querySelector(".cust-screens-main").classList.toggle("open");
}

document.addEventListener("input",(e)=>{
  const inputEl = e.target
  if(!inputEl.closest(".cust-screens-wrapper")) return;
  const box = e.target.closest(".cust-screens-wrapper")
  const allInputs = box.querySelectorAll(".cust-selection-options input");
  const reviewItemList = box.querySelector(".cust-items-list");
  let sum = 0;
  const selectedAdons = box.querySelectorAll(".cust-selection-options input:checked")
  // console.log(selectedAdons)
  reviewItemList.innerHTML = "";
  selectedAdons.forEach((selIn)=>{
    let inPrice = Number(selIn.dataset.price)
    if(inPrice){
      sum+=inPrice
    }
    let listItem = document.createElement("li");
    listItem.classList.add("cust-item");
    let itemTitle = document.createElement("span");
    itemTitle.textContent = selIn.name=="prescription" ? "Type" : selIn.name;
    let itemName = document.createElement("span");
    itemName.textContent = selIn.dataset.name;
    listItem.appendChild(itemTitle);
    listItem.appendChild(itemName);
    reviewItemList.appendChild(listItem);
  })
  box.querySelectorAll(".cust-f-total-price , .cust-item-total>span").forEach((el) => {
    el.textContent = `Rs. ${sum.toLocaleString('en-IN')}`;
  });
})  


function updateMaterial(custBox){
  if(custBox.querySelector(".cust-selection-options input[name='material']:checked")){
    custBox.querySelector(".cust-screens-footer-right[data-btn='2'] .cust-screen-continue-btn").removeAttribute("disabled");
  }else{
    custBox.querySelector(".cust-screens-footer-right[data-btn='2'] .cust-screen-continue-btn").setAttribute("disabled",true);

  }
}


function changeScreen(btn,screenNo){
    btn.closest(".cust-screens-wrapper").setAttribute("data-screen",screenNo)
}



// set prescription on-off

function changePrescription(el){
  const custBox = el.closest(".cust-screens-main")
  const selected = custBox.querySelector(".cust-selection-options input[name='prescription']:checked").value;
  const wrapperEl = custBox.querySelector(".cust-screens-wrapper");
   if(selected=="no-prescription"){
        const materialRadio = custBox.querySelector(".cust-selection-options input[name='material']:checked");
        wrapperEl.classList.add("remove-screen-2");
        if (materialRadio) {
            materialRadio.checked = false;
            updateMaterial(custBox)
        }
    }else{
       wrapperEl.classList.remove("remove-screen-2");
   }
}

// set prescription on-off



// submited --------------------

function submitCustomize(el){
  const screenEl = el.closest(".cust-screens-main");

    document.querySelector(".pdp-loader-screen")?.classList.add("loading");
    document.querySelector(".cust-screens-main.open").classList.remove("open");
    const productTitle = screenEl.dataset.title.trim();
    const productColor = screenEl.dataset.productColor.trim();
    const productVariant =  el.closest("product-info").querySelector("product-form .product-variant-id");
    const prescription =  screenEl.querySelector(".cust-selection-options input[name='prescription']:checked");
    const material =  screenEl.querySelector(".cust-selection-options input[name='material']:checked");
    const lenseColor =  screenEl.querySelector(".cust-selection-options input[name='lens-color']:checked");
    const bluFilt =  screenEl.querySelector(".cust-selection-options input[name='filter']:checked");
    let blueFiltVarId = 48276979908867;
    let lenseColorVarId = lenseColor?.value;
    let ColumbiaResinVarId = 48275236913411;
    let antiReflVarId = 48275090014467;


    const sharedProperties = {
    };

    // add only if exists
    if (bluFilt?.value === "blue-light-filter") {
    sharedProperties.Adon = "Blue Light Filter";
    }

    if (material?.value === "Anti-reflective") {
    sharedProperties.Material = "Anti-reflective Lenses";
    }

    if (material?.value === "columbia-resin") {
    sharedProperties.Material = "Crizal Columbia Resin Lenses";
    }

    if (lenseColorVarId) {
    sharedProperties.Lens_Colour = lenseColor.getAttribute("data-name");
    }

    let itemsArr = [];

    if (productVariant?.value) {
    itemsArr.push({
        id: Number(productVariant.value),
        quantity: 1,
        properties: {
            ...sharedProperties,
        }
    });
    }

    if (bluFilt?.value === "blue-light-filter" && blueFiltVarId) {
    itemsArr.push({
        id: Number(blueFiltVarId),
        quantity: 1,
        properties: {
            Product : productTitle+" - "+productColor
        }
    });
    }

    if (material?.value === "Anti-reflective" && antiReflVarId) {
    itemsArr.push({
        id: Number(antiReflVarId),
        quantity: 1,
        properties: {
            Product : productTitle+" - "+productColor
        }
    });
    }

    if (material?.value === "columbia-resin" && ColumbiaResinVarId) {
    itemsArr.push({
        id: Number(ColumbiaResinVarId),
        quantity: 1,
        properties: {
            Product : productTitle+" - "+productColor
        }
    });
    }

    if (lenseColorVarId) {
        itemsArr.push({
        id: Number(lenseColorVarId),
        quantity: 1,
        properties: {            
          Product : productTitle+" - "+productColor
        }
    });
    }

    // Remove duplicates
    itemsArr = [...new Set(itemsArr)];

    addMultipleVariantsToCart(itemsArr);
    screenEl.querySelector(".cust-selection-options input[name='prescription']").checked = true;
    if(material){
      material.checked = false;
    }
    if(lenseColor){
      lenseColor.checked = false;
    }
    if(bluFilt){
      bluFilt.checked = false;
    }
    
    changeScreen(material,1);
    screenEl.querySelector(".cust-items-list").innerHTML = "<li class='cust-item'><span>Type</span><span>No Prescription</span></li>";
    screenEl.querySelectorAll(".cust-f-total-price , .cust-item-total>span").forEach((el) => {
      el.textContent = 'Rs. 0';
    });
    screenEl.querySelector(".cust-screens-footer-right[data-btn='2'] .cust-screen-continue-btn")?.setAttribute("disabled",true);
}

async function addMultipleVariantsToCart(items) {
  try {
    if (!Array.isArray(items) || !items.length) {
      console.error('No valid items to add');
      return;
    }

    // 1. CLEAN ITEMS (keep properties intact)
    const cleanItems = items
      .filter(item => item && item.id && !isNaN(item.id))
      .map(item => ({
        id: Number(item.id),
        quantity: item.quantity || 1,
        properties: item.properties || {}
      }));

    // 2. ADD TO CART
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: cleanItems })
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      console.error('Shopify Error Response:', data);
      throw new Error(data?.description || 'Failed to add items');
    }

    // 3. UPDATE DAWN CART DRAWER
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const sections = cartDrawer.getSectionsToRender().map(s => s.id);

    const sectionResponse = await fetch(`/cart?sections=${sections.join(',')}`);
    const sectionsData = await sectionResponse.json();

    cartDrawer.renderContents({
      sections: sectionsData
    });

    // 4. OPEN DRAWER SAFELY
    setTimeout(() => {
      cartDrawer.classList.add('active');
      cartDrawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
      cartDrawer.focus();
      document.querySelector(".pdp-loader-screen.loading")?.classList.remove("loading");

    }, 50);

  } catch (error) {
    console.error('Cart Error:', error);
  }
}


// submited --------------------

// -------- NEW Customize Change Variant START --------
function changeVariant(disabled=false,wrapper){
  if(disabled){
    wrapper.querySelector(".pdp-customize-btn").classList.add("p-sold-out");
  }else{
    wrapper.querySelector(".pdp-customize-btn").classList.remove("p-sold-out");
  }
}
// -------- NEW Customize Change Variant END --------